import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). On web this content renders
// inside FilterProductsModal's Container drawer (surfaceElevated), so the
// panel surfaces match that elevation.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.surfaceElevated,
      paddingHorizontal: 24,
    },
    headerComponent: {
      backgroundColor: colors.surfaceElevated,
      paddingVertical: 30,
      paddingLeft: 24,
      paddingRight: 8,
    },
    whiteBackground: {
      backgroundColor: colors.surfaceElevated,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginBottom: 8,
    },
    leftButton: {
      flex: 1,
    },
    rightButton: {
      flex: 1,
      marginLeft: 16,
    },
    pb24: {
      paddingBottom: 24,
    },
    checkboxTitle: {
      fontSize: 18,
      color: colors.textMuted,
    },
    modalView: {
      flex: 1,
      alignSelf: 'flex-end',
      width: '25%',
    },
    checkboxStyle: {
      height: 16,
      width: 16,
    },
  });

export default makeStyles;
